// PrivacyPolicy
import { axiosApiInstance } from "../App";
import { url } from "./url.service";

const serverUrl = url + "/policy";

export const addPrivacyPolicy = (formData) => {
  return axiosApiInstance.post(serverUrl + "/", formData);
};

export const getPrivacyPolicy = (query) => {
  return axiosApiInstance.get(`${serverUrl}/`);
};

export const deletePrivacyPolicy = (id) => {
  return axiosApiInstance.delete(`${serverUrl}/deleteById/${id}`);
};

export const updatePrivacyPolicy = (formData, id) => {
  return axiosApiInstance.patch(`${serverUrl}/updateById/${id}`, formData);
};
